import { AsYouType, parseDigits } from "libphonenumber-js";

const checkValue = FormInput => {
  const element = $(FormInput);
  // check if the input has any value (if we've typed into it)
  if (element.val()) {
    const inputValue = element.val();
    if (element.attr("type") === "tel") {
      const formattedNumber = new AsYouType("US").input(
        parseDigits(inputValue.toString())
      );
      element.val(formattedNumber);
    }
    element.parent(".float-label-wrapper").addClass("has-value");
  } else {
    element.parent(".float-label-wrapper").removeClass("has-value");
  }
};

$(document).ready(() => {
  // Run on page load
  $(".float-label").each((index, element) => checkValue(element));
  // Run on input exit
  $(".float-label")
    .blur(e => checkValue(e.target))
    .change(e => !$(e.target).hasClass("has-value") && checkValue(e.target))
    .keyup(e => !$(e.target).hasClass("has-value") && checkValue(e.target));
});
